// extracted by mini-css-extract-plugin
module.exports = {"team_manager_card_header_title":"TeamManager_team_manager_card_header_title__1tQ7O"};